/*
 * tol-kouza-facets.js — 講座の絞り込み（開講月・時間帯・金額・対象者・講師）（2026-10・講座の検索性）
 * ------------------------------------------------------------------
 * 読み込み = sections/tol-collection-grid.liquid（school_mode / kouza_mode で設定 kouza_facets が ON のとき・defer）。
 * 欄 = snippets/tol-kouza-facets.liquid（[data-tol-kf]）・カードのデータ = snippets/tol-kouza-facets-data.liquid（[data-kf]）。
 *
 * - ブラウザの中だけで絞る（fetch も URL の書き換えもしない）。メタフィールドは増やさない（ユーザー裁定）。
 * - 同じ項目の中は OR、項目どうしは AND。選択肢はページ内のカードから組み立てる（該当なしの選択肢は出さない）。
 * - 絞り込みで外れたカードには data-kf-out="1" を付ける。表示の決め方は器ごとに違う:
 *   ・スクール別（tol-school-grid）: 協会グループごとに「残ったカード」で 10 件ずつのページを振り直し、
 *     ページ番号ボタンと件数バッジを作り直す。外れたカードは data-page="0"（どのページにも出ない）。
 *     ページ番号ボタンの押下は従来どおり tol-school-grid.js（data-page で出し分け）が処理する。
 *     残りが 0 件の協会グループは隠す。パネル（開催校／オンライン校）が丸ごと 0 件なら案内を出す。
 *   ・講座コレクション（tol-kouza-grid）: スクールボタンの絞り込み（data-tol-kouza-school-out）と合わせて
 *     どちらかで外れたら hidden。tol-kouza-grid.js はスクールを変えたら window.tolKouzaFacets.refresh() を呼ぶ。
 * - 規律: IIFE・二重初期化ガード・shopify:section:load で再初期化。
 */
(function () {
  'use strict';
  if (window.__tolKouzaFacetsLoaded) return;
  window.__tolKouzaFacetsLoaded = true;

  var SLOT_LABELS = { am: '午前（12時まで）', pm: '午後（12〜17時）', ev: '夜間（17時以降）' };
  var SLOT_ORDER = ['am', 'pm', 'ev'];

  function split(v) {
    return (v || '').split('|').map(function (s) { return s.trim(); }).filter(Boolean);
  }
  function uniq(arr) {
    var seen = {};
    return arr.filter(function (v) {
      if (seen[v]) return false;
      seen[v] = true;
      return true;
    });
  }
  function yen(n) {
    return Number(n).toLocaleString('ja-JP');
  }
  function monthLabel(ym) {
    var p = ym.split('-');
    return p[0] + '年' + parseInt(p[1], 10) + '月';
  }
  function parseBands(str) {
    return (str || '').split(',').map(function (b) {
      var p = b.split('-');
      var min = parseInt(p[0], 10) || 0;
      var max = p[1] === '' || p[1] == null ? Infinity : parseInt(p[1], 10);
      var label = max === Infinity ? yen(min) + '円〜' : (min === 0 ? '〜' + yen(max) + '円' : yen(min) + '〜' + yen(max) + '円');
      return { key: b, min: min, max: max, label: label };
    }).filter(function (b) { return b.key; });
  }

  function init(root) {
    if (!root || root.dataset.tolKfInit) return;
    root.dataset.tolKfInit = '1';
    var scope = root.closest('[data-tol-collection-grid]') || document;
    var cards = Array.prototype.slice.call(scope.querySelectorAll('[data-kf]'));
    if (!cards.length) return; /* カードが無ければ欄を出さない（hidden のまま） */

    var bands = parseBands(root.getAttribute('data-kf-bands'));
    var data = cards.map(function (el) {
      return {
        el: el,
        months: split(el.getAttribute('data-kf-months')),
        slots: split(el.getAttribute('data-kf-slots')),
        price: parseInt(el.getAttribute('data-kf-price'), 10),
        instructor: (el.getAttribute('data-kf-instructor') || '').trim(),
        audience: split(el.getAttribute('data-kf-audience'))
      };
    });
    data.forEach(function (d) {
      d.bands = isNaN(d.price) ? [] : bands.filter(function (b) { return d.price >= b.min && d.price < b.max; }).map(function (b) { return b.key; });
    });

    var state = { months: {}, slots: {}, bands: {}, audience: {}, instructor: '' };

    /* ---- 選択肢を組み立てる ---- */
    function all(key) {
      var out = [];
      data.forEach(function (d) { out = out.concat(d[key]); });
      return uniq(out);
    }
    var optionSets = {
      months: all('months').sort().map(function (v) { return { value: v, label: monthLabel(v) }; }),
      slots: SLOT_ORDER.filter(function (s) { return all('slots').indexOf(s) !== -1; }).map(function (v) { return { value: v, label: SLOT_LABELS[v] }; }),
      bands: bands.filter(function (b) { return all('bands').indexOf(b.key) !== -1; }).map(function (b) { return { value: b.key, label: b.label }; }),
      audience: all('audience').sort(function (a, b) { return a.localeCompare(b, 'ja'); }).map(function (v) { return { value: v, label: v }; })
    };
    var anyGroup = false;
    Object.keys(optionSets).forEach(function (key) {
      var group = root.querySelector('[data-tol-kf-group="' + key + '"]');
      var box = group && group.querySelector('[data-tol-kf-options]');
      if (!group || !box) return;
      var opts = optionSets[key];
      if (opts.length < 2 && key !== 'months') return; /* 選択肢が 1 つしか無い項目は絞る意味が無いので出さない（開講月は 1 つでも出す） */
      if (!opts.length) return;
      opts.forEach(function (o) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tol-kf__chip';
        b.setAttribute('aria-pressed', 'false');
        b.setAttribute('data-tol-kf-key', key);
        b.setAttribute('data-tol-kf-value', o.value);
        b.textContent = o.label;
        box.appendChild(b);
      });
      group.hidden = false;
      anyGroup = true;
    });
    var instructors = all('instructor').filter(Boolean).sort(function (a, b) { return a.localeCompare(b, 'ja'); });
    var instGroup = root.querySelector('[data-tol-kf-group="instructor"]');
    var select = root.querySelector('[data-tol-kf-select]');
    if (instGroup && select && instructors.length >= 2) {
      instructors.forEach(function (name) {
        var o = document.createElement('option');
        o.value = name;
        o.textContent = name;
        select.appendChild(o);
      });
      instGroup.hidden = false;
      anyGroup = true;
    }
    if (!anyGroup) return;
    root.hidden = false;

    /* 2026-10: 欄は PC・SP とも最初は閉じた状態（details に open を付けない・開きたい人だけ開く） */
    var activeBox = root.querySelector('[data-tol-kf-active]');
    var activeList = root.querySelector('[data-tol-kf-active-list]');

    /* ---- 判定 ---- */
    function hasAny(obj) {
      return Object.keys(obj).some(function (k) { return obj[k]; });
    }
    function hit(set, values) {
      if (!hasAny(set)) return true;
      return values.some(function (v) { return set[v]; });
    }
    function matches(d) {
      return hit(state.months, d.months) &&
        hit(state.slots, d.slots) &&
        hit(state.bands, d.bands) &&
        hit(state.audience, d.audience) &&
        (!state.instructor || d.instructor === state.instructor);
    }
    function active() {
      return hasAny(state.months) || hasAny(state.slots) || hasAny(state.bands) || hasAny(state.audience) || !!state.instructor;
    }

    /* ---- 反映 ---- */
    function relayoutSchoolGroups() {
      Array.prototype.forEach.call(scope.querySelectorAll('[data-tol-school-body]'), function (body) {
        var group = body.closest('.tol-school-grid__group');
        var items = Array.prototype.slice.call(body.querySelectorAll('[data-tol-school-card]'));
        if (!items.length) return;
        if (!body.dataset.kfPerPage) {
          var firstPage = items.filter(function (it) { return it.getAttribute('data-page') === '1'; }).length;
          body.dataset.kfPerPage = String(firstPage || 10);
        }
        var per = parseInt(body.dataset.kfPerPage, 10) || 10;
        var n = 0;
        items.forEach(function (it) {
          if (it.getAttribute('data-kf-out') === '1') {
            it.setAttribute('data-page', '0');
            it.hidden = true;
            return;
          }
          var page = Math.floor(n / per) + 1;
          n += 1;
          it.setAttribute('data-page', String(page));
          it.hidden = page !== 1;
        });
        var pages = Math.ceil(n / per);
        var nav = body.querySelector('[data-tol-school-pagination]');
        if (pages > 1) {
          if (!nav) {
            nav = document.createElement('nav');
            nav.className = 'tol-school-grid__pagination';
            nav.setAttribute('data-tol-school-pagination', '');
            nav.setAttribute('aria-label', 'ページ');
            body.appendChild(nav);
          }
          var html = '';
          for (var p = 1; p <= pages; p++) {
            html += '<button type="button" class="tol-school-grid__page' + (p === 1 ? ' is-active' : '') + '" data-page="' + p + '"' + (p === 1 ? ' aria-current="page"' : '') + '>' + p + '</button>';
          }
          nav.innerHTML = html;
          nav.hidden = false;
        } else if (nav) {
          nav.hidden = true;
        }
        var badge = group && group.querySelector('.tol-school-grid__toggle-count');
        if (badge) badge.textContent = badge.textContent.replace(/^\d+/, String(n));
        if (group) group.hidden = n === 0;
      });
      Array.prototype.forEach.call(scope.querySelectorAll('[data-tol-school-panel]'), function (panel) {
        var visibleGroups = Array.prototype.some.call(panel.querySelectorAll('.tol-school-grid__group'), function (g) { return !g.hidden; });
        var msg = panel.querySelector(':scope > .tol-kf__panel-empty');
        if (!visibleGroups) {
          if (!msg) {
            msg = document.createElement('p');
            msg.className = 'tol-kf__panel-empty';
            msg.textContent = '条件に合う講座がありません。条件を変えてお試しください。';
            panel.appendChild(msg);
          }
          msg.hidden = false;
        } else if (msg) {
          msg.hidden = true;
        }
      });
    }

    function apply() {
      var count = 0;
      data.forEach(function (d) {
        var ok = matches(d);
        if (ok) count += 1;
        if (ok) d.el.removeAttribute('data-kf-out');
        else d.el.setAttribute('data-kf-out', '1');
        if (d.el.hasAttribute('data-tol-kouza-card')) {
          d.el.hidden = !ok || d.el.getAttribute('data-tol-kouza-school-out') === '1';
        }
      });
      if (scope.querySelector('[data-tol-school-body]')) relayoutSchoolGroups();

      var isActive = active();
      var countEl = root.querySelector('[data-tol-kf-count]');
      if (countEl) countEl.textContent = isActive ? count + '件' : '';
      var empty = root.querySelector('[data-tol-kf-empty]');
      if (empty) empty.hidden = !(isActive && count === 0);
      Array.prototype.forEach.call(root.querySelectorAll('[data-tol-kf-clear]'), function (b) { b.disabled = !isActive; });
      renderActive(isActive);
    }

    /* 絞り込み中の条件チップ（欄の外・閉じていても見える）。× で 1 つずつ外せる */
    function renderActive(isActive) {
      if (!activeBox || !activeList) return;
      activeList.textContent = '';
      if (!isActive) {
        activeBox.hidden = true;
        return;
      }
      Array.prototype.forEach.call(root.querySelectorAll('[data-tol-kf-key][aria-pressed="true"]'), function (chip) {
        addActive(chip.textContent, function () { chip.click(); });
      });
      if (state.instructor && select) {
        addActive('講師：' + state.instructor, function () {
          select.value = '';
          state.instructor = '';
          apply();
        });
      }
      activeBox.hidden = false;
    }
    function addActive(label, onRemove) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tol-kf__active-chip';
      b.setAttribute('aria-label', label + ' の条件を外す');
      b.innerHTML = '<span></span><span class="tol-kf__active-x" aria-hidden="true">×</span>';
      b.firstChild.textContent = label;
      b.addEventListener('click', onRemove);
      li.appendChild(b);
      activeList.appendChild(li);
    }

    root.addEventListener('click', function (e) {
      var chip = e.target.closest ? e.target.closest('[data-tol-kf-key]') : null;
      if (chip) {
        var key = chip.getAttribute('data-tol-kf-key');
        var val = chip.getAttribute('data-tol-kf-value');
        var on = chip.getAttribute('aria-pressed') !== 'true';
        chip.setAttribute('aria-pressed', on ? 'true' : 'false');
        chip.classList.toggle('is-active', on);
        state[key][val] = on;
        apply();
        return;
      }
      if (e.target.closest && e.target.closest('[data-tol-kf-clear]')) {
        state = { months: {}, slots: {}, bands: {}, audience: {}, instructor: '' };
        Array.prototype.forEach.call(root.querySelectorAll('[data-tol-kf-key]'), function (c) {
          c.setAttribute('aria-pressed', 'false');
          c.classList.remove('is-active');
        });
        if (select) select.value = '';
        apply();
      }
    });
    if (select) {
      select.addEventListener('change', function () {
        state.instructor = select.value;
        apply();
      });
    }

    root._tolKfApply = apply;
  }

  function initAll(ctx) {
    Array.prototype.forEach.call((ctx || document).querySelectorAll('[data-tol-kf]'), init);
  }

  /* tol-kouza-grid.js（スクールボタン）から呼ぶ: スクールを変えた後に表示を合わせ直す */
  window.tolKouzaFacets = {
    refresh: function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-tol-kf]'), function (r) {
        if (r._tolKfApply) r._tolKfApply();
      });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();